<div *ngIf="notifications.length" class="notifications" [class.rtl]="layoutService.websiteDirection$.value === 'rtl'">
    <div *ngFor="let notification of notifications" class="notification">
        <ng-container *ngTemplateOutlet="notificationTpl;context:{notification:notification}"></ng-container>
    </div>
</div>

<ng-template #notificationTpl let-notification="notification">
    <app-notification-item class="notification" [notification]="notification" (notificationClicked)="onNotificationClicked($event)"></app-notification-item>
</ng-template>